// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css';
// import '!style-loader!css-loader!less-loader!./myTheme/index.less'
import  "./myTheme/index.less"

import "babel-polyfill";
import store from "./store/index.js"
//font-awesome图标库
import 'font-awesome/scss/font-awesome.scss';
//v-viewer大图预览
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import echarts from 'echarts';
Vue.prototype.$echarts = echarts;

import $ from 'jquery' 
window.$ = window.jQuery = $

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});

Vue.use(ViewUI);
Vue.use(Viewer);



// WEBPACK FOOTER //
// ./src/main.js